// extracted by mini-css-extract-plugin
module.exports = {"root":"ReportDetails_root__1UBYi","header":"ReportDetails_header__3OXrL","title":"ReportDetails_title__2XCKE","left":"ReportDetails_left__2eCVg"};